import React from 'react'

import { Logo, LogoBeta, LogoQA, LogoPreview } from '../Logo'
import { TopNavigation, TopNavigationItem } from '../TopNavigation'

export type SiteHeaderProps = {
  activeMenu?: string
  environment: string
  isOverlayOpen: boolean
  navigation: any
  handleCloseClick: () => void
  handleLogoClick: () => void
  handleMenuClick: (item: TopNavigationItem) => void
  handleSearchClick: () => void
  showLangPrefSelector?: boolean
  handlePreferencesClick?: () => void
  languageSlug?: string
  toggleLanguage: (selectedLang: string) => void
}
const languagesToDisplay = [
  {
    languageCode: 'en',
    language: 'English'
  },
  {
    languageCode: 'zh-cn',
    language: '中文简体'
  },
  {
    languageCode: 'ja',
    language: '日本語'
  }
]

export const TOP_ANCHOR_ID = 'back-to-top'

export const SiteHeader = ({
  activeMenu = '',
  environment = 'default',
  isOverlayOpen,
  navigation,
  handleCloseClick,
  handleLogoClick,
  handleMenuClick,
  handleSearchClick,
  showLangPrefSelector = false,
  languageSlug = 'en',
  handlePreferencesClick = () => {},
  toggleLanguage
}: SiteHeaderProps) => {
  type LogoSelect = {
    [key: string]: object
  }

  const logo: LogoSelect = {
    qa: <LogoQA />,
    beta: <LogoBeta />,
    preview: <LogoPreview />,
    default: <Logo />
  }

  const logoClickHandler = (
    e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => {
    e.preventDefault()
    handleLogoClick()
  }

  return (
    <header className="header" id={TOP_ANCHOR_ID}>
      <div className="wrapper--1 content">
        <div className="region region--logo">
          <div className="logo__wrapper">
            <a
              href="/"
              onClick={logoClickHandler}
              onKeyUp={logoClickHandler}
              data-testid="logo"
            >
              {logo[environment] ? logo[environment] : logo.default}
            </a>
          </div>
        </div>
        <TopNavigation
          {...navigation}
          handleCloseClick={handleCloseClick}
          handleSearchClick={handleSearchClick}
          handleMenuClick={handleMenuClick}
          isOverlayOpen={isOverlayOpen}
          activeMenu={activeMenu}
          showLangPrefSelector={showLangPrefSelector}
          handlePreferencesClick={handlePreferencesClick}
          languageSlug={languageSlug}
          toggleLanguage={toggleLanguage}
          languagesToDisplay={languagesToDisplay}
        />
      </div>
    </header>
  )
}
export default SiteHeader
